import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const userAgent = navigator.userAgent;
const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
let loadSyncFusion = true;
if (isSafari) {
  // Extract Safari version from the user agent
  const versionMatch = userAgent.match(/Version\/(\d+\.\d*)/);
  if (versionMatch) {
    loadSyncFusion = Number(versionMatch[1]) > 16.2;
  }
}

if (loadSyncFusion) {
  const syncfusion = import('@syncfusion/ej2-base');
  syncfusion.then(({ registerLicense }) => {
    registerLicense(environment.synfusionKey);
  });
}
if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
